import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vias-datecombo',
  templateUrl: './datecombo.component.html',
  styleUrls: ['./datecombo.component.scss']
})
export class DatecomboComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
